/**
 * Lien unique du QuickSupport METERIS — servi sur la page publique, aux côtés d'AnyDesk.
 *
 * `meteris-connect-quicksupport.exe` : self-extractor d'un seul tenant (22 Mo). Le client
 * le double-clique, rien ne s'installe, aucun droit administrateur n'est demandé, et le
 * programme disparaît quand il le ferme. Serveur METERIS et clé sont compilés dedans :
 * il n'y a rien à saisir.
 *
 * ── Pourquoi un binaire distinct de MeterisConnect ───────────────────────────
 * Il est compilé sous APP_NAME = `MeterisAssist`, ce qui lui donne ses propres dossiers
 * de config, son propre nom de service et son propre scheme URI. C'est ce qui le rend
 * invisible pour `install-meteris-connect.ps1`, dont le nettoyage fait
 *   Get-Process -Name MeterisConnect | Stop-Process -Force
 * Un QuickSupport portant le même nom serait tué au moment précis où le technicien
 * installe le client permanent — il perdrait la session par laquelle il travaille.
 * C'était la limite de TeamViewer QuickSupport ; compiler notre client la lève.
 *
 * ⚠️ Limite résiduelle, mesurée : le self-extractor embarque le binaire sous le nom
 * `rustdesk.exe` (l'empaquetage s'exécute avant l'étape de renommage du build). Sur un
 * poste portant ENCORE RustDesk vanilla, `Remove-VanillaRustDesk` tue les process nommés
 * `rustdesk` et couperait donc la session. Sans effet sur un poste neuf : la fonction
 * sort immédiatement quand il n'y a ni service ni dossier RustDesk. Disparaît une fois
 * les postes dual-stack purgés.
 *
 * Ce lien vit ici et nulle part ailleurs : le faire diverger enverrait une partie des
 * clients vers un fichier périmé, sans que rien ne le signale.
 */
export const LIEN_ASSISTANCE = '/api/downloads/meteris-connect-quicksupport.exe';

export default LIEN_ASSISTANCE;
